import { render, staticRenderFns } from "./BoxPhotoSession.vue?vue&type=template&id=8f60d7ea&scoped=true"
import script from "./BoxPhotoSession.vue?vue&type=script&lang=js"
export * from "./BoxPhotoSession.vue?vue&type=script&lang=js"
import style0 from "./BoxPhotoSession.vue?vue&type=style&index=0&id=8f60d7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f60d7ea",
  null
  
)

export default component.exports